import userApi from "api/user";
import { Button, Col, Form, Input, Row, Select, Tooltip } from "antd";
import { forwardRef, useImperativeHandle } from "react";
import { SearchOutlined, RollbackOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";

const FormFilter = forwardRef(function FormFilter({ setDataTable, optionsStore, optionsRole }, ref) {
  const [form] = Form.useForm();
  const { t } = useTranslation()

  const onReset = async () => {
    const res = await userApi.getUsers();
    setDataTable(res.users);
    form.resetFields();
  };

  const onSubmitForm = async (values) => {
    const res = await userApi.getUsers();

    const newDataTable = res.users.filter(
      (user) =>
        (values.name ? user.name.toLowerCase().includes(values.name.toLowerCase()) : true) &&
        (values.shop ? user.shops.some((el) => el.shop?._id == values.shop) : true) &&
        (values.role ? user.role == values.role : true)
    );

    setDataTable(newDataTable);
  };

  useImperativeHandle(ref, () => ({
    onSearch() {
      onSubmitForm(form.getFieldsValue());
    },
  }));

  return (
    <>
      <Form layout="vertical" form={form} onFinish={onSubmitForm}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item name="name" label={t('fullName')}>
              <Input placeholder={t('fullName')} maxLength={32} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="shop" label={t('shop')}>
              <Select placeholder={t('shop')} options={optionsStore} allowClear />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name="role" label={t('position')}>
              <Select placeholder={t('position')} options={optionsRole} allowClear />
            </Form.Item>
          </Col>
          <Col span={3} offset={18}>
            <Form.Item>

              <Tooltip title={t('search')}>
                <Button style={{ width: "100%" }} htmlType="submit" type="primary">
                  <SearchOutlined />  </Button>
              </Tooltip>

            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item>
              <Tooltip title={t('reset')}>
                <Button onClick={onReset} style={{ width: "100%" }}>
                  <RollbackOutlined />
                </Button>
              </Tooltip>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </>
  );
});

export default FormFilter;
